try{
  if((window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openURL) || (window && window.AndroidBridge && window.AndroidBridge.openURL) ||
     (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openURLNew) || (window && window.AndroidBridge && window.AndroidBridge.openURLNew))
  {
    if(navigator.userAgent.includes("Mobile")){
      $('head').append('<link rel="stylesheet" href="https://d3myyafggcycom.cloudfront.net/STAGING/7357bd30-bf02-11ec-a94c-06fa44be0788/uploads/admin/profile-page-style-v3.css" type="text/css" />');
      $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">');
      $("#PAFloaterContainer").css("display", "none");
      $("#admin-bar-iframe").css("display", "none");
      $('.thsb_cp_back_btn').css("display", "none");

    } else{
	  $("#shopify-section-header").css("display", "block");
      $("#shopify-section-footer").css("display", "block");
    }

  } else{
      $("#shopify-section-header").css("display", "block");
      $("#shopify-section-footer").css("display", "block");
  }
} catch(err){
	console.log(err);
}
// console.log(document.getElementById("PAFloaterContainer"));
// console.log(document.getElementById("admin-bar-iframe"));